import type { TourSection } from './types';

// Estudio de fotos (sección TEMPORAL, ver `src/features/photo-studio/index.ts`).
//
// En el celular se ve la lista o el producto abierto, no los dos: los steps
// de la parte escondida se saltan igual que los del paso 2 (ver abajo).
//
// Los targets del paso 2 (sección 'photos') solo existen con un SKU elegible
// en pantalla, y el de la revisión recién con al menos una foto procesada.
// Antes de eso Joyride espera cada uno 1 s (`targetWaitTimeout`) y lo salta:
// el tour no se cuelga, pero esos steps no se ven hasta que su parte de la
// pantalla aparece.
export const photoStudioSections: TourSection[] = [
  {
    id: 'about',
    label: 'Para qué sirve',
    steps: [
      {
        target: '[data-tour="photo-studio-header"]',
        title: 'Estudio de fotos',
        content:
          'Sirve para preparar fotos de productos que todavía no tienen ninguna. El sistema mejora cada foto de forma automática y tú decides cuáles se guardan.',
      },
    ],
  },
  {
    id: 'pending',
    label: 'Elegir el producto',
    steps: [
      {
        target: '[data-tour="photo-studio-pending-filters"]',
        title: 'Filtrar la lista',
        content:
          'La lista muestra los productos que todavía no tienen ninguna foto. Al entrar se ven solo los activos y activos en ecommerce; desmarca "Solo activos" o "Solo activos en ecommerce" para ver también los inactivos. También puedes filtrar por marca o categoría, o buscar por SKU o nombre.',
      },
      {
        target: '[data-tour="photo-studio-pending-results"]',
        title: 'Elegir un producto',
        content:
          'Toca un producto para abrirlo y tomarle fotos. Cada uno muestra si está activo en ecommerce. Se ven 50 a la vez; usa "Cargar más" para ver los siguientes. Cuando subes las fotos de un producto, sale de la lista.',
      },
      {
        target: '[data-tour="photo-studio-pending-search"]',
        title: 'Ir directo a un SKU',
        content:
          'Si buscas un SKU y no aparece, puede que ya tenga fotos o que esté inactivo en ecommerce. Usa "Revisar el SKU" para ver el producto y el motivo. Escríbelo tal como aparece en el sistema, con las mismas mayúsculas y minúsculas.',
      },
    ],
  },
  {
    id: 'confirm',
    label: 'Confirmar el producto',
    steps: [
      {
        target: '[data-tour="photo-studio-result"]',
        title: 'Confirmar antes de tomar fotos',
        content:
          'Aquí aparecen el nombre, la marca, la categoría y el estado en ecommerce del producto que elegiste. Compáralos con el producto que tienes en la mano antes de tomar fotos. Debajo verás si se le pueden agregar fotos y, si no, por qué: por ejemplo, porque otra fuente ya tiene fotos de ese producto.',
      },
    ],
  },
  {
    id: 'photos',
    label: 'Tomar, revisar y subir fotos',
    steps: [
      {
        target: '[data-tour="photo-studio-tray"]',
        title: 'Agregar fotos',
        content:
          'Toma fotos con la cámara del teléfono o del computador, elígelas desde el equipo o arrástralas hasta aquí, hasta 10 por producto. Usa buena luz, que se vea el producto completo y que nada lo toque, ni el papel del SKU: mientras mejor la foto, menos tiene que cambiarla el sistema.',
      },
      {
        target: '[data-tour="photo-studio-process"]',
        title: 'Mejorar las fotos',
        content:
          'Envía las fotos para que el sistema les ponga fondo blanco y centre el producto. Cada una tarda unos 20 segundos. Nada llega a master hasta que lo apruebes y lo subas; si cierras la pantalla, las fotos quedan guardadas en este navegador para retomarlas.',
      },
      {
        target: '[data-tour="photo-studio-review"]',
        title: 'Revisar antes de subir',
        content:
          'Compara cada foto con su resultado. La mejora automática puede cambiar textos pequeños o logos, así que amplía la foto y revísalos antes de aprobarla. Elige la foto principal y sube: solo se guardan las que apruebes.',
      },
    ],
  },
];
